import React from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";

/**
 * InstituteFormModal — Create/Edit institute in a modal.
 * Reusable for both add and edit flows.
 */
const InstituteFormModal = ({ show, onHide, onSubmit, formData, setFormData, loading, isEdit = false }) => {
  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="fs-6 fw-semibold">
          {isEdit ? "Edit Institute" : "Add New Institute"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small fw-medium">Institute Name *</Form.Label>
                <Form.Control
                  size="sm"
                  value={formData.name || ""}
                  onChange={handleChange("name")}
                  required
                  placeholder="Enter institute name"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small fw-medium">Email</Form.Label>
                <Form.Control
                  size="sm"
                  type="email"
                  value={formData.email || ""}
                  onChange={handleChange("email")}
                  placeholder="admin@example.com"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small fw-medium">Phone</Form.Label>
                <Form.Control
                  size="sm"
                  value={formData.phone || ""}
                  onChange={handleChange("phone")}
                  placeholder="Phone number"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small fw-medium">Address</Form.Label>
                <Form.Control
                  size="sm"
                  value={formData.address || ""}
                  onChange={handleChange("address")}
                  placeholder="City, State"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small fw-medium">Currency</Form.Label>
                <Form.Select
                  size="sm"
                  value={formData.currency || "INR"}
                  onChange={handleChange("currency")}
                >
                  <option value="INR">INR (₹)</option>
                  <option value="USD">USD ($)</option>
                  <option value="EUR">EUR (€)</option>
                  <option value="GBP">GBP (£)</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small fw-medium">Status</Form.Label>
                <Form.Select
                  size="sm"
                  value={formData.status || "active"}
                  onChange={handleChange("status")}
                >
                  <option value="active">Active</option>
                  <option value="trial">Trial</option>
                  <option value="inactive">Inactive</option>
                  <option value="suspended">Suspended</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small fw-medium">Subdomain</Form.Label>
                <div className="d-flex align-items-center gap-1">
                  <Form.Control
                    size="sm"
                    value={formData.subdomain || ""}
                    onChange={handleChange("subdomain")}
                    placeholder="my-institute"
                  />
                  <span className="text-muted small" style={{ whiteSpace: 'nowrap' }}>.lmscampus.com</span>
                </div>
                <Form.Text className="text-muted" style={{ fontSize: '0.7rem' }}>
                  Leave blank to auto-generate from the name
                </Form.Text>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="small fw-medium">GST Number</Form.Label>
                <Form.Control
                  size="sm"
                  value={formData.gstNumber || ""}
                  onChange={handleChange("gstNumber")}
                  placeholder="Optional"
                />
              </Form.Group>
            </Col>
            {isEdit && (
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="small fw-medium">Payment Type</Form.Label>
                  <Form.Select
                    size="sm"
                    value={formData.paymentType || "own_gateway"}
                    onChange={handleChange("paymentType")}
                  >
                    <option value="own_gateway">Own Gateway</option>
                    <option value="lms_payment">LMS Payment (Platform)</option>
                  </Form.Select>
                  <Form.Text className="text-muted" style={{ fontSize: '0.7rem' }}>
                    Switching from LMS to Own Gateway requires all payouts to be settled first
                  </Form.Text>
                </Form.Group>
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" size="sm" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" size="sm" type="submit" disabled={loading}>
            {loading ? "Saving…" : isEdit ? "Update Institute" : "Create Institute"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default InstituteFormModal;
